<template>
    <v-row>
      <v-dialog v-model="showDialog" scrollable max-width="750px">
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <v-card v-if="!loading">
          <v-card-title>
            <v-panel>
               <span style="font-size: 20px;">
                  {{ st('wkt.admin.customer.support.dialog.new-message') }}
               </span>
            </v-panel>
          </v-card-title>
          <v-card-text>
            <v-container>
                  <v-form ref="form">
                     <v-row>
                        <v-col cols="6" class="pb-0" v-if="isAdmin">  
                           <v-switch dense
                              v-model="data.isPublic"
                              :label="st('wkt.admin.customer.support.dialog.visible-to-customer')"
                           ></v-switch>
                        </v-col>
                           
                        <v-col cols="12">  
                           <tiptap-vuetify v-model="data.message" 
                              :placeholder="editorPlaceholder"
                              :extensions="extensions" :card-props="{ flat: true }" />
                        </v-col>

                        <v-col cols="12">       
                           <v-file-input
                              multiple chips truncate-length="45"
                              :label="st('wkt.admin.customer.support.dialog.attachments')"
                              v-model="files"
                           ></v-file-input>
                        </v-col>
                     </v-row>
                  </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn v-if="data.id" color="#ff0000" @click="confirmDelete()">
                          <v-icon left color="#ffffff">delete</v-icon>
                          <span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
                      </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!canSendMessage" color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
            <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
          <ConfirmDialog ref="dlgConfirm"
              v-bind:title="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.title')"
              v-bind:message="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.text')"
              v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
              v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
              v-on:confirmed="deleteItem()"
          />
    </v-row>	
  </template>
  
<script>
import BaseModule from '../../../common/BaseModule.js'
import ConfirmDialog from '../../../common/ConfirmDialog'
import api from '../../../../api/worktime'
import { TiptapVuetify, Bold, Italic, Strike, Underline, Code, BulletList, OrderedList, ListItem, Link, Blockquote, History } from 'tiptap-vuetify'

//import gwt from '../../../../api/gwt' 

export default {
   name: 'SuportTicketMessageDialog',
   mixins: [BaseModule],
   props: ['isAdmin'],
   components: {
      ConfirmDialog, TiptapVuetify
   },
   data() {
      return {
         showDialog: false,
         loading: true,
         files: null,
         data: {},
         extensions: [
               History,
               Blockquote,
               Link,
               Underline,
               Strike,
               Italic,
               ListItem,
               BulletList,
               OrderedList,
               Bold,
               Code
            ],
      }
   },
   computed: {
      editorPlaceholder() {
         return this.st('wkt.admin.customer.support.dialog.message-placeholder');
      },
      canSendMessage() {
         return this.data.message && this.data.message.length > 20;
      }
   },
   methods: {
      // eslint-disable-next-line no-unused-vars
      open: function (ticketId) {

         this.showDialog = true;
         this.loading=false;
         this.files = null;

         if (this.$refs.form) {
            this.$refs.form.resetValidation();
         }

         this.data= { 
            ticketId: ticketId,
            isPublic: !this.isAdmin,
            message: null};
      },
      onSave: async function () {
         if (!this.$refs.form.validate() || !this.data.message) {
            return;
         }

         this.loading = true;
         try {
            const actualMessage = this.data.message.replace('<a href=','<a target="_blank" href=');
            const payload = await api.buildSupportTicketMessagePayload(this.data.ticketId, this.data.isPublic, actualMessage, this.files);

            // eslint-disable-next-line no-unused-vars
            api.storeSupportTicketMessage(this.isAdmin, this.data.ticketId, payload,res => {
                  this.loading = false;
                  if (res.id) {
                     this.$emit('refresh');
                     this.showDialog = false;
                  } else {
                     this.$emit('show-alert',{ text: res.message, color: 'error', timeout: 3000 });
                  }
               },
               error => {
                  this.$log.error(error);
                  this.loading = false;
                  this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
               });
         } catch (error) {
            this.$log.error(error);
            this.loading = false;
            this.$emit('show-alert',{ text: error && error.message ? error.message : error, color: 'error', timeout: 3000 });
         }
      },
      confirmDelete() {
         this.$refs.dlgConfirm.confirm(this.data);
      },
      deleteItem() {
        this.loading = true;
        // eslint-disable-next-line no-unused-vars
         api.deleteExternalDocumentCategory(this.isAdmin,this.data.id, res => {
               this.showDialog = false;
               this.loading = false;
               this.$emit('refresh');
            },
            (error) => {
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            }
         );
      }
   },
}
</script>
